module.exports = __webpack_public_path__ + "static/media/Woonzorggroep_Vredenoord.384363fb.svg";